import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import Form from 'apps/auth/components/form-multi/Form';
import { deactivateAccountDisclaimerFields } from 'apps/auth/components/form-multi/utils';
import ProfileSmsConfirmModal from 'apps/auth/components/profile/settings/ProfileSmsConfirmModal';
import BasePage from 'apps/auth/components/utils/BasePage';
import ModalNew from 'apps/auth/components/utils/ModalNew';
import { TOKEN_ID, USER_NAME, USER_TOKEN_PHONE } from 'apps/auth/constants/Constants';
import { AUTH_PROFILE_SETTINGS, AUTH_SECURITY, AUTH_SECURITY_DEACTIVATE_ACCOUNT_ACTION } from 'apps/auth/constants/UrlConstants';
import { useExtra } from 'apps/auth/hooks/selectors';
import Cookies from 'universal-cookie';

const DeactivateAccountDisclaimerPage = (props) => {
    const FORM_NAME = 'deactivateAccountDisclaimer';
    const popupRef = useRef(null);
    const modalRef = useRef(null);
    const { hideCreationOfPassword } = useExtra();

    useEffect(() => {
        props.setNewForm(FORM_NAME, deactivateAccountDisclaimerFields(), AUTH_SECURITY_DEACTIVATE_ACCOUNT_ACTION);
    }, [props.securitySubmit]);

    const fields = props.forms[FORM_NAME];

    const submitHandler = () => {
        const cookies = new Cookies();
        const expiredDate = new Date();
        expiredDate.setFullYear(expiredDate.getFullYear() - 1);
        if (cookies.get(TOKEN_ID)) {
            cookies.set(TOKEN_ID, '', { path: '/', expires: expiredDate });
            cookies.set(USER_NAME, '', { path: '/', expires: expiredDate });
        }
        cookies.set(USER_TOKEN_PHONE, '', { path: '/', expires: expiredDate });
        props.toggleModal(true, <ProfileSmsConfirmModal popupRef={popupRef} />);
    };

    return (
        <>
            <CommonPage backUrl={hideCreationOfPassword ? AUTH_PROFILE_SETTINGS : AUTH_SECURITY} hasBottomPanel>
                <HeaderPanel title={props.deactivateHeader} />
                <div className="maincopy">
                    <div dangerouslySetInnerHTML={{ __html: props.securityAccountDeactivationDisclaimerText }} />
                    {fields && (
                        <Form formName={FORM_NAME} fields={fields} onSubmitHandler={submitHandler} action={AUTH_SECURITY_DEACTIVATE_ACCOUNT_ACTION}>
                            <FixedBottomPanel>
                                <Button variant={'danger'} caption={props.securitySubmit} />
                            </FixedBottomPanel>
                        </Form>
                    )}
                </div>
            </CommonPage>
            <PopupNew ref={popupRef} />
            <ModalNew ref={modalRef} />
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        forms: state.form,
        securityAccountDeactivationDisclaimerText: state.messages.pageMessages.securityAccountDeactivationDisclaimerText,
        securitySubmit: state.messages.pageMessages.securitySubmit,
        deactivateHeader: state.messages.pageMessages.deactivateHeader,
    };
};
export default connect(mapStateToProps, {
    setNewForm,
    toggleModal,
})(BasePage(DeactivateAccountDisclaimerPage));
